/**
 * @file paddlex 下载
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';
import { DownOutlined } from '@ant-design/icons';

import Header from '../../../../components/header/HeaderWithStore';
import Footer from '../../../../components/footer/footer';
import Banner from '../../../../components/banner/Banner';
import DownloadIcons from './components/download-icons/DownloadIcons';
import usePaddlexDownloadHooks from './paddlexDownloadHooks';
import MarkdownContainer from '../../../../components/markdown-container/MarkdownContainer';
import HistoryVersionTable from '../../components/history-version-table/HistoryVersionTable';
import A from '../../../../components/a/A';

const PaddleSuilteDownload: React.FC = () => {
    const {
        downloads,
        changelog,
        recommendedEnvironment,
        historyVersion,

        onDownloadClick
    } = usePaddlexDownloadHooks();

    return (
        <div className="page paddlex-download-page">
            <Header />
            <Banner
                title="PaddleX 图形化开发界面下载"
                className="paddlex-download-banner"
                subtitle="请下载PaddleX安装包，如有任何问题，欢迎加入PaddleX官方QQ群169608643。"
                divider
            />
            <div className="paddlex-download-container">
                <div className="paddlex-download-h2">快速下载最新版本</div>
                <DownloadIcons
                    windows={downloads.windows}
                    mac={downloads.mac}
                    linux={downloads.linux}
                    onDownloadClick={onDownloadClick}
                />
                <div className="paddlex-download-h2">更新日志</div>
                <div className="paddlex-download-text-card">
                    <MarkdownContainer source={changelog} />
                </div>
                <div className="paddlex-download-h2">推荐安装环境</div>
                <div className="paddlex-download-text-card">
                    <MarkdownContainer source={recommendedEnvironment} />
                </div>
                <div className="paddlex-download-h2">历史版本</div>
                <HistoryVersionTable dataSource={historyVersion} pagination={false} />
                <div className="paddlex-download-more-history">
                    <A href="/paddlex/history">
                        更多历史版本 <DownOutlined />
                    </A>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default PaddleSuilteDownload;
